// Русский справочник фраз
export const WIDGET_MESSAGES_RU = {
  errors: {
    rateLimit: 'Превышен лимит запросов',
    rateLimitFiles: 'Вы превысили лимит количества загружаемых файлов',
    rateLimitMessages: 'Вы превысили лимит количества отправленных сообщений',
    fileUploadCount: (maxFiles: number) => `К сообщению можно прикрепить не более ${maxFiles} файлов`,
    fileUploadSize: (maxMb: number) => `Файлы размером больше ${maxMb}Мб не будут добавлены к сообщению`,
    fileUploadAll: (maxFiles: number, maxMb: number) =>
      `К сообщению можно прикрепить не более ${maxFiles} файлов по ${maxMb}Мб каждый`,
  },
  phone: {
    overlayTitle: 'Введите номер',
    overlayContinue: 'Продолжить',
    overlayCancel: 'Отмена',
    overlaySubtitle: 'привязанный к аккаунту в мессенджере MAX',
    overlayBackAria: 'Назад',
    selectCountryCode: 'Выберите код страны',
    selectCountry: 'Выберите страну',
    empty: 'Введите номер телефона',
    minLength: (minLength: number) => `Номер телефона должен содержать не менее ${minLength} цифр`,
    invalidFormat: 'Недопустимый формат номера',
  },
  chat: {
    you: 'Вы',
    placeholder: 'Напишите сообщение...',
    startChatTitle: 'Начните чат',
    startChatDescription: 'Опишите свою проблему, и мы постараемся вам помочь',
    messageNotSent: 'Сообщение не отправлено',
    loadHistory: 'История сообщений',
    rateAnswerTitle: 'Оцените ответ',
    rateAnswerOf: 'из',
  },
  attach: {
    photoFromDevice: 'Фото с устройства',
    file: 'Файл',
    fileError: 'Ошибка файла',
  },
  lock: {
    limit: 'Отправка сообщений ограничена',
    unavailable: 'Чат недоступен',
    banIntro: 'Администратор запретил вам отправлять сообщения.',
    banCanWritePrefix: 'Написать новые можно',
    chatClosed: 'Чат закрыт.',
    newDialog: 'Начать новый диалог',
    afterTime: 'после',
  },
  dates: {
    today: 'сегодня',
    yesterday: 'вчера',
  },
};
